import { runInAction } from "mobx";

import { RecentDocumentsStore } from "@/store/RecentDocumentsStore";
import { useStore } from "@/store/RootStoreProvider";

export function useRecentDocuments(): RecentDocumentsStore {
  const rootStore = useStore();

  if (!rootStore.recentDocuments) {
    runInAction(() => {
      if (!rootStore.recentDocuments) {
        rootStore.recentDocuments = new RecentDocumentsStore(rootStore);
      }
    });
  }

  return rootStore.recentDocuments!;
}
